import { EnumDropdown } from 'framework/form';
import { APPROVAL_TYPE_OPTIONS } from 'domain/shared/newProject';

type ApprovalTypeSelectorProps = {
  source: string;
  disabled?: boolean;
};

const ApprovalTypeSelector = ({ source, disabled = false }: ApprovalTypeSelectorProps) => {
  return <EnumDropdown source={source} label="Approval type" options={APPROVAL_TYPE_OPTIONS} disabled={disabled} />;
};

export default ApprovalTypeSelector;
